let language = {
    RETURN_DETAIL_SUBMIT_EXPRESS: "提交快递信息",
    RETURN_DETAIL_TEACKING_NO: "快递单号:",
    RETURN_DETAIL_EXPRESS: "快递公司:",

};

export { language }
